<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField style="margin: 0.1rem 0.1rem 0.1rem 0;width:20%" labelWidth="0" type="text" id="code"
                                    v-model="form.scrapOrder" placeholder="操作单号"
                                    @update:modelValue="(value) => handleModelValueUpdate('scrapOrder', value)"
                        />
                        <SelectField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0.7rem;padding:0 0.2rem;width:20%;" :options="statusList"
                                     v-model="form.status" id="status" placeholder="审核状态"
                                     @update:modelValue="(value) => handleModelValueUpdate('status', value)"
                        />
                        <RangePickerField
                                id="time"
                                label-width="0"
                                v-model="form.time"
                                style="width: 40%;"
                                :placeholder="['开始申请时间', '结束申请时间']"
                                :disabled="false"
                            @update:modelValue="(value) => handleModelValueUpdate('time', value)"
                        />
                        <a-space style="margin: 0 0 0 0.5rem;width:25%">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
                    <div class="right">
                        <ButtonField text="报废" @click="$emit('show-scrap-add')" secondary />
                    </div>
                </div>
            </form>
        </div>
        <Tablelist
                style="margin-top: 1rem"
                :showCheckbox="false"
                :list="list"
                :totalSize="totalSize"
                :totalPages="totalPages"
                :pageNum="pageNum"
                :pageSize="pageSize"
                :columns="tableColumns"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a v-if="item.status === 'REVIEWING' || item.status === 'REJECTED'"
                        @click="$emit('show-scrap-edit',item.id)" >重新申请</a>
                    <a @click="$emit('show-scrap-detail',item.id)">
                        <span v-if="item.status === 'REVIEWING'">审核</span>
                        <span v-else>详情</span>
                    </a>
                    <a class="danger" v-if="item.status !== 'APPROVED' && item.status !== 'CANCELLED'"
                        @click.prevent="cancelText(item)">取消申请</a>
                    <a class="danger" v-if="item.status !== 'APPROVED' && item.status !== 'DELETED'"
                        @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
    </div>
</template>
<script>
import { fetchList, cancel, remove } from "../api/scrap";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      form: {
          scrapOrder:null,
          status:null,
          time:null,
      },
      list: [],
      loading: false,
      totalSize: 0,
      totalPages: 0,
      pageNum: 1,
      pageSize: 10,
      tableColumns: [
        {
            key: 'scrapOrder',
            title: '操作单号',
            field: 'scrapOrder',
            infotype: 'text'
        },
        {
            key: 'scrapTime',
            title: '报废时间',
            field: 'scrapTime',
            infotype: 'text',
        },
        {
            key: 'applicant',
            title: '申请人',
            field: 'applicant',
            infotype: 'text',
        },
        {
            key: 'status',
            title: '审核状态',
            field: 'status',
            infotype: 'dictType',
            dictType:'AssetReviewStatus'
        },
        {
            key: 'reviewer',
            title: '审核人员',
            field: 'reviewer',
            infotype: 'text',
        },
        {
            key: 'reviewTime',
            title: '审核时间',
            field: 'reviewTime',
            infotype: 'text',
        },
        {
            key: 'actions',
            title: '操作',
            infotype: 'template',
        }
    ],
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("AssetReviewStatus");
    },
  },
  methods: {
     handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
    },
    getList() {
      this.loading = true;
      let { form } = this;

      let scrapTimeStart, scrapTimeEnd;
      if (Array.isArray(form.time) && form.time.length === 2) {
        scrapTimeStart = form.time[0].format("YYYY-MM-DD");
        scrapTimeEnd = form.time[1].format("YYYY-MM-DD");
      }
      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...form,
        time: undefined,
        scrapTimeStart,
        scrapTimeEnd,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.totalSize = res.totalSize;
            this.totalPages = res.totalPages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },

    cancelText(text) {
      const that = this;
      this.$confirm({
        title: "确认要取消吗？",
        onOk() {
          cancel({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.logQuery{
  display: flex;
  justify-content: start;
  //width: 80%;
}
.right ::v-deep Button{
  margin: 0 0.2rem;
}
</style>